<template>
  <div v-if="isLoad" class="main fixed top-0 left-0 w-full h-full z-50 flex justify-center items-center">
    <div class="progress-bar2"></div>
  </div>
  <div v-else class="fixed top-0 left-0 w-full h-full bg-black/80 z-50 flex justify-center items-center">
    <button class="absolute top-0 right-3 text-4xl text-white hover:cursor-pointer" @click="closeImage">&times;</button>
    <div class="w-full h-full flex justify-center items-center">
      <img :src="image" class="max-w-[90vw] max-h-[80vh]" />
    </div>
  </div>
</template>
<script setup>
defineProps({
  image: String,
  isLoad: Boolean,
});
const emit = defineEmits(["closeImage"]);
const closeImage = () => {
  emit("closeImage");
};

</script>


<style scoped>
.main {
  background: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));
}

.progress-bar2 {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background:
    radial-gradient(closest-side, white 80%, transparent 82% 100%),
    conic-gradient(#F2B611 75%, #005CFF 0);
  animation: animate 3s linear infinite;
}

@keyframes animate {
  0% {
    transform: rotate(0);
  }

  100% {
    transform: rotate(360deg);
  }

}
</style>